import type {
  MerchantLoginResponse,
  MerchantForgotPasswordVerifyOtpResponse,
  MerchantChangePasswordVerifyResponse,
} from "@/api/auth-service/generated-sources";
import {
  MerchantLoginAction,
  MerchantLoginModel,
  MerchantForgotPasswordVerifyOtpModel,
  MerchantChangePasswordVerifyModel,
} from "@/models/MerchantAuthModel";

export function mapMerchantLoginModel(
  dto: MerchantLoginResponse | undefined,
): MerchantLoginModel {
  return {
    action:
      (dto?.action as MerchantLoginAction | undefined) ??
      MerchantLoginAction.TOKEN_ISSUED,
    tokenType: dto?.tokenType,
    accessToken: dto?.accessToken,
    refreshToken: dto?.refreshToken,
    expiresIn: dto?.expiresIn,
    sessionToken: dto?.sessionToken,
    redirect: dto?.redirect,
    channel: dto?.channel,
    otpExpiresIn: dto?.otpExpiresIn,
    resendCooldownSeconds: dto?.resendCooldownSeconds,
  };
}

export function mapMerchantForgotPasswordVerifyOtpModel(
  dto: MerchantForgotPasswordVerifyOtpResponse | undefined,
): MerchantForgotPasswordVerifyOtpModel {
  return {
    resetSessionToken: dto?.resetSessionToken ?? "",
    expiresIn: dto?.expiresIn ?? 0,
  };
}

export function mapMerchantChangePasswordVerifyModel(
  dto: MerchantChangePasswordVerifyResponse | undefined,
): MerchantChangePasswordVerifyModel {
  return {
    sessionId: dto?.sessionId ?? "",
    token: dto?.token ?? "",
    expiresIn: dto?.expiresIn ?? 0,
  };
}
